function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.weak-map.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _classPrivateFieldSet(s, a, r) { return s.set(_assertClassBrand(s, a), r), r; }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
var _mainStore = /*#__PURE__*/new WeakMap();
var _postcode = /*#__PURE__*/new WeakMap();
var _city = /*#__PURE__*/new WeakMap();
var _latitude = /*#__PURE__*/new WeakMap();
var _longitude = /*#__PURE__*/new WeakMap();
var CustomerContext = /*#__PURE__*/function () {
  function CustomerContext(mainStore, postcode, city, latitude, longitude) {
    _classCallCheck(this, CustomerContext);
    _classPrivateFieldInitSpec(this, _mainStore, void 0);
    _classPrivateFieldInitSpec(this, _postcode, void 0);
    _classPrivateFieldInitSpec(this, _city, void 0);
    _classPrivateFieldInitSpec(this, _latitude, void 0);
    _classPrivateFieldInitSpec(this, _longitude, void 0);
    _classPrivateFieldSet(_mainStore, this, mainStore);
    _classPrivateFieldSet(_postcode, this, postcode);
    _classPrivateFieldSet(_city, this, city);
    _classPrivateFieldSet(_latitude, this, latitude);
    _classPrivateFieldSet(_longitude, this, longitude);
  }
  return _createClass(CustomerContext, [{
    key: "getMainStore",
    value: function getMainStore() {
      return _classPrivateFieldGet(_mainStore, this);
    }
  }, {
    key: "getPostcode",
    value: function getPostcode() {
      return _classPrivateFieldGet(_postcode, this);
    }
  }, {
    key: "getCity",
    value: function getCity() {
      return _classPrivateFieldGet(_city, this);
    }
  }, {
    key: "getLatitude",
    value: function getLatitude() {
      return _classPrivateFieldGet(_latitude, this);
    }
  }, {
    key: "getLongitude",
    value: function getLongitude() {
      return _classPrivateFieldGet(_longitude, this);
    }
  }]);
}();
export { CustomerContext as default };